import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api'
import { DashboardOverview, RevenueAnalytics, UserAnalytics, UsageAnalytics } from '@/types'

export type AnalyticsPeriod = '7d' | '30d' | '90d' | '6m' | '1y'

const ANALYTICS_QUERY_KEY = 'analytics'

export const useDashboardOverview = (period: AnalyticsPeriod = '30d') => {
  return useQuery<DashboardOverview>({
    queryKey: [ANALYTICS_QUERY_KEY, 'overview', period],
    queryFn: async () => {
      const { data } = await api.get(`/analytics/overview?period=${period}`)
      return data
    },
    refetchInterval: 5 * 60 * 1000,
  })
}

export const useRevenueAnalytics = (period: AnalyticsPeriod = '30d') => {
  return useQuery<RevenueAnalytics>({
    queryKey: [ANALYTICS_QUERY_KEY, 'revenue', period],
    queryFn: async () => {
      const { data } = await api.get(`/analytics/revenue?period=${period}`)
      return data
    },
  })
}

export const useUserAnalytics = (period: AnalyticsPeriod = '30d') => {
  return useQuery<UserAnalytics>({
    queryKey: [ANALYTICS_QUERY_KEY, 'users', period],
    queryFn: async () => {
      const { data } = await api.get(`/analytics/users?period=${period}`)
      return data
    },
  })
}

export const useUsageAnalytics = (period: AnalyticsPeriod = '30d') => {
  return useQuery<UsageAnalytics>({
    queryKey: [ANALYTICS_QUERY_KEY, 'usage', period],
    queryFn: async () => {
      const { data } = await api.get(`/analytics/usage?period=${period}`)
      return data
    },
  })
}
